import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useConfig } from 'builder/hooks/useConfig'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions as uiActions } from 'builder/modules/ui'
import { selectors as userSelectors } from 'builder/modules/user'
import { i18n as I18n } from 'builder/utils/i18n'
import { ButtonTheme } from 'builder/components/Button'
import SubscriptionCancelledIcon from '../../../../../app/assets/images/subscription_cancellation/new-subscription-cancelled.png'
import SubscriptionCancelledIconOld from '../../../../../app/assets/images/subscription_cancellation/subscription_cancelled.png'
import {
  ButtonsContainer,
  CancelledIcon,
  DashboardButton,
  Description,
  KeepDataButton,
  ReactivateContainer,
  ReactivateText,
  Title,
  WhiteDashboardButton,
} from './styles'

const SubscriptionCancelledView = () => {
  const config = useConfig()
  const dispatch = useDispatch()
  const user = useTypedSelector(userSelectors.userData)
  const isSubscriptionV4Enabled = config?.features.subCancellationV4 || false

  const handleModalOpen = useCallback(() => {
    dispatch(uiActions.openRestartSubscriptionModal())
  }, [dispatch])

  const getImage = () => {
    return isSubscriptionV4Enabled ? SubscriptionCancelledIcon : SubscriptionCancelledIconOld
  }

  const subscriptionLastDate = new Date(user?.billingInfo.premiumEndsAt || '')
  const month = I18n.t(`builder.date.month.${subscriptionLastDate.getMonth() + 1}`)
  const year = subscriptionLastDate.getFullYear()
  const date = subscriptionLastDate.getDate()

  const reactivateText = I18n.t(
    'builder.subscription_cancellation_v4.cancelled_view.reactivate_text',
  )

  return (
    <>
      {config?.features.reactivatePremium && user?.billingInfo.canRestartSubscription && (
        <ReactivateContainer>
          <ReactivateText dangerouslySetInnerHTML={{ __html: reactivateText }} />
        </ReactivateContainer>
      )}
      <CancelledIcon src={getImage()} />
      <Title>
        {isSubscriptionV4Enabled
          ? I18n.t('builder.subscription_cancellation_v4.cancelled_view.subscription_canceled')
          : I18n.t('builder.subscription_cancellation.cancelled_view.subscription_canceled')}
      </Title>
      <Description isCancelled={!isSubscriptionV4Enabled}>
        {isSubscriptionV4Enabled ? (
          <>
            {I18n.t('builder.subscription_cancellation_v4.cancelled_view.description_line_one')}
            <span className="important">{` ${month} ${date}, ${year}. `}</span>
            {I18n.t('builder.subscription_cancellation_v4.cancelled_view.description_line_two')}
          </>
        ) : (
          I18n.t('builder.subscription_cancellation.cancelled_view.description')
        )}
      </Description>
      {config?.features.reactivatePremium && user?.billingInfo.canRestartSubscription ? (
        <ButtonsContainer>
          <WhiteDashboardButton as={Link} to="/" theme={ButtonTheme.ghost}>
            {I18n.t('builder.subscription_cancellation.cancelled_view.back')}
          </WhiteDashboardButton>
          <KeepDataButton
            onClick={() => {
              handleModalOpen()
              trackInternalEvent('click_keep_premium', { where: 'sub_cancellation' })
            }}
          >
            {I18n.t('builder.subscription_cancellation_v4.cancelled_view.restart_subscription')}
          </KeepDataButton>
        </ButtonsContainer>
      ) : (
        <DashboardButton as={Link} to="/">
          {I18n.t('builder.subscription_cancellation.cancelled_view.back')}
        </DashboardButton>
      )}
    </>
  )
}

export default SubscriptionCancelledView
